import React, { Component } from 'react'
import AdminBlog from './pages/AdminBlog'
import AdminCalendar from './pages/AdminCalendar'
import AdminFeatured from './pages/AdminFeatured'

class Admin extends Component {
  constructor() {
    super()
    this.state = {
      currentView: "featured"
    }
  }

  setView = (view) => {
    this.setState({currentView: view})
  }

  render() {
    let currentComponent = null
    if (this.state.currentView === "blog") { currentComponent = <AdminBlog/> }
    if (this.state.currentView === "calendar") { currentComponent = <AdminCalendar/> }
    if (this.state.currentView === "featured") { currentComponent = <AdminFeatured/> }
    
    return (
      <div className="w-100 bg-moon-gray flex flex-column ph3">
        <section className="flex flex-column flex-row-ns justify-around items-center pathway mt3 mb5">
          <div className={`link pathway card pointer bg-animate ph3 pv2 mb2 mb0-ns w-100 w-auto-ns f4 f3-ns tc near-white ${this.state.currentView === "blog" ? "bg-dark-gray" : "bg-gray"}`} 
               onClick={() => this.setView("blog")}>
                BLOG
          </div>
          <div className={`link pathway card pointer bg-animate ph3 pv2 mb2 mb0-ns w-100 w-auto-ns f4 f3-ns tc near-white ${this.state.currentView === "calendar" ? "bg-dark-gray" : "bg-gray"}`} 
               onClick={() => this.setView("calendar")}>
                CALENDAR
          </div>
          <div className={`link pathway card pointer bg-animate ph3 pv2 mb2 mb0-ns w-100 w-auto-ns f4 f3-ns tc near-white ${this.state.currentView === "featured" ? "bg-dark-gray" : "bg-gray"}`} 
               onClick={() => this.setView("featured")}>
                FEATURED LINKS
          </div>
          <div className="link pathway card pointer bg-animate bg-very-red ph3 pv2 mb2 w-100 w-auto-ns mb0-ns f4 f3-ns tc near-white" 
               onClick={this.props.logout}>
                LOG OUT
          </div>
        </section>

        {currentComponent}

      </div>  
    )
  }
}

export default Admin


// WEBPACK FOOTER //
// ./src/components/admin/Admin.js